/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Valore } from './valore';


export interface MiaAccettazione { 
    versione?: number;
    accettato_at?: string;
    spunte?: Array<Valore>;
}

